export function ItemBullet() {
  return (
    <div className="w-[6px] h-[6px] bg-white rounded-[50%] mr-[15px]"></div>
  );
}
